import type { TransactionsContext } from '@/queries/transactionsContext.query'

const DEPOSIT_STEPS: NonNullable<TransactionsContext>['depositSteps'] = [
  { name: 'deposit', actions: ['deposit'], actionsUrl: 'url' },
]

const REDEEM_STEPS: NonNullable<TransactionsContext>['redeemSteps'] = [
  { name: 'redeem', actions: ['redeem'], actionsUrl: 'url' },
]

export const PLACEHOLDER_ACTIONS_DETAILS: NonNullable<TransactionsContext> = {
  allSteps: [...DEPOSIT_STEPS, ...REDEEM_STEPS],
  depositSteps: DEPOSIT_STEPS,
  currentDepositStep: DEPOSIT_STEPS[0].name,
  redeemSteps: REDEEM_STEPS,
  currentRedeemStep: REDEEM_STEPS[0].name,
  asset: {
    address: '0x4200000000000000000000000000000000000006',
    assetCaip: 'eip155:8453/erc20:0x4200000000000000000000000000000000000006',
    assetGroup: 'ETH',
    name: 'Wrapped Ether',
    symbol: 'WETH',
    decimals: 18,
    balanceNative: '0',
    balanceUsd: '0',
    positionValueInAsset: '0',
  },
  lpToken: {
    address: '',
    tokenCaip: '',
    name: '',
    symbol: '',
    decimals: 0,
    balanceNative: '',
    balanceUsd: '',
  },
  additionalAssets: [],
  childrenPositions: [],
  rewards: {
    claimable: [],
    currentStep: 'deposit',
    steps: [],
  },
}
